/**
 * InterrupterRow is the DXL module used for row interrupter ads.
 *
 * @module views/components/InterrupterRow
 * @memberof -Common
 */
import './InterrupterRow.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Modules from '@ulta/core/components/Modules/Modules';


/**
 * Represents a InterrupterRow component
 *
 * @method
 * @param { InterrupterRowProps} props - React properties passed from composition
 * @returns InterrupterRow
 */
export const InterrupterRow = function( props ){
  const { modules } = props;
  if( !modules ){
    return null;
  }
  return (
    <div
      className='InterrupterRow'
      role='region'
      aria-label='promotion'
    >
      <Modules
        modules={ modules }
      />
    </div>
  );
};

/**
 * Property type definitions
 * @typedef InterrupterRowProps
 * @type {object}
 * @property {array} modules - modules of interrupterrow
 */
export const propTypes =  {
  modules: PropTypes.array
};

InterrupterRow.propTypes = propTypes;



export default React.memo( InterrupterRow );
